import React, {useEffect, useState} from "react";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {Grid, TextField, Typography} from "@mui/material";
import ButtonGroup from '@mui/material/ButtonGroup';
import {useNavigate, useSearchParams} from 'react-router-dom';
import "./OneShot.css";
import useMediaQuery from '@mui/material/useMediaQuery';
import {styled, useTheme} from '@mui/material/styles';
import Button from '@mui/material/Button';
import {getCookie, setCookie} from '../../utils/Functions';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay} from 'swiper/modules';
import 'swiper/css';

import Slide from '@mui/material/Slide';
//Images
import fondoDonacion from "../../assets/imgs/unicef/OneShot/teleton2025/banner-Desktop.png"
import mobileFondoDonacion from "../../assets/imgs/unicef/OneShot/teleton2025/banner-Mobile.png"
import fondoPrincipal from "../../assets/imgs/unicef/OneShot/teleton2025/banner-Desktop.png"
import mobileFondoPrincipal from "../../assets/imgs/unicef/OneShot/teleton2025/banner-Mobile.png"

// Reusable Components
const DonarAhoraButton = ({ onClick, text = "DONAR AHORA", mobile = false, customText = false }) => (
    <button
        onClick={onClick}
        style={{
            backgroundColor: '#EE5B28',
            color: '#ffffff',
            border: 'none',
            borderRadius: '35px',
            padding: mobile ? '12px 30px' : '15px 40px',
            fontSize: mobile ? (customText ? '16px' : '18px') : '20px',
            fontWeight: 'bold',
            fontFamily: 'inherit',
            cursor: 'pointer',
            textTransform: 'uppercase'
        }}
        className="font-face-UniversBold"
    >
        {text}
    </button>
);

const WhiteSection = ({ children, mobile = false, textAlign = "center", padding = null }) => (
    <section style={{
        backgroundColor: '#ffffff',
        width: '100%',
        padding: padding || (mobile ? '30px 20px' : '40px 10.4%'),
        textAlign
    }}>
        {children}
    </section>
);

const ColorButton = styled(Button)(({theme}) => ({
    color: theme.palette.getContrastText("#fff"),
    fontSize: 20,
    fontWeight: "700",
    padding: 1,
    height: 65,
    borderRadius: 3,
    width: "100%",
    backgroundColor: "#ffff00",
    '&:hover': {
        backgroundColor: "#fff",
        color: "#000"
    },
}));

const OneShot = (props) => {

    const navigate = useNavigate();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [showAmount, setShowAmount] = useState(false);
    const [error, setError] = useState("");
    const [isFirstClick, setIsFirstClick] = useState(true);

    const [amount, setAmount] = useState(120);
    const [imgDonacion, setImgDonacion] = useState(false);
    const [searchParams] = useSearchParams();

    const [isFooterVisible, setIsFooterVisible] = useState(false);

    // Image constants - centralized image paths
    const BASE_URL = process.env.REACT_APP_URL_CONFIG;
    const ASSETS = `${BASE_URL}/assets/imgs/unicef/teleton2026`;
    const IMAGES = {
        kids: {
            kid1: `${BASE_URL}/assets/imgs/teleton2025/kid1.png`,
            kid2: `${BASE_URL}/assets/imgs/teleton2025/kid2.png`,
            kid3: `${BASE_URL}/assets/imgs/teleton2025/kid3.png`,
            kid4: `${BASE_URL}/assets/imgs/teleton2025/kid4.png`,
            kid5: `${BASE_URL}/assets/imgs/teleton2025/kid5.png`,
            kid6: `${BASE_URL}/assets/imgs/teleton2025/kid6.png`
        },
        teleton: {
            banner1: `${BASE_URL}/assets/imgs/teleton2025/teleton-banner1.png`
        }
    };

    // Legacy variable names for compatibility
    const kid1 = IMAGES.kids.kid1;
    const kid2 = IMAGES.kids.kid2;
    const teletonBanner1 = IMAGES.teleton.banner1;
    const kid11 = IMAGES.kids.kid2;
    const kid12 = IMAGES.kids.kid3;
    const kid13 = IMAGES.kids.kid4;
    const kid5 = IMAGES.kids.kid5;
    const kid6 = IMAGES.kids.kid6;

    const [finalData, setFinalData] = useState({

        utm_source: searchParams.get("utm_source") ? searchParams.get("utm_source") : "false",
        utm_medium: searchParams.get("utm_medium") ? searchParams.get("utm_medium") : "false",
        utm_campaign: searchParams.get("utm_campaign") ? searchParams.get("utm_campaign") : "false",
        utm_id: searchParams.get("utm_id") ? searchParams.get("utm_id") : "false",
        utm_term: searchParams.get("utm_term") ? searchParams.get("utm_term") : "false",
        utm_content: searchParams.get("utm_content") ? searchParams.get("utm_content") : "false"
    })

    const handleChange = (event) => {

        if (event.target.value === "") {
            setAmount(event.target.value)
        } else {

            if (/^[0-9]+$/.test(event.target.value)) {
                //
                setError("")
                setAmount(event.target.value)
                if (event.key === 'Enter') {
                    //
                    donate(event)
                }
            }
        }
    };
    const donate = (event) => {
        //
        if (parseInt(amount) >= 50) {
            if (process.env.REACT_APP_URL_CONFIG === "https://www.unicef.org.bo") {
                window.fbq('track', 'AddToCart', {
                    content_type: 'product',
                    value: amount,
                    currency: "BOB"
                });
                window.gtag("event", "add_to_cart", {
                    currency: "BOB",
                    value: amount,
                    items: [
                        {
                            item_id: "SKU_DONACION",
                            item_name: "Donación de " + amount + "Bs",
                            price: amount,
                            quantity: 1
                        }
                    ]
                });
            } else {

            }

            setTimeout(() => {

                window.scrollTo(0, 0)
            }, 100);
            navigate("/donacion-unica-completar/" + amount);
        } else {
            setError("El monto debe ser mayor a Bs 50")
        }
    }

    useEffect(() => {

        setTimeout(() => {
            window.scrollTo(0, 0)
        }, 100);

        let utm_source = ""
        let utm_id = ""
        let utm_content = ""
        let utm_medium = ""
        let utm_campaign = ""
        let utm_term = ""
        let _finalData = finalData

        if (searchParams.get("utm_source")) {
            utm_source = searchParams.get("utm_source")

            _finalData["utm_source"] = utm_source
        } else {
            utm_source = getCookie(process.env.REACT_APP_NAME + "utm_source")
            if (!utm_source || utm_source === "undefined" || utm_source === undefined || utm_source === null || utm_source === "null") {
                utm_source = ""
            }
            _finalData["utm_source"] = utm_source
        }

        if (searchParams.get("utm_term")) {
            _finalData["utm_term"] = utm_term
            utm_term = searchParams.get("utm_term")
        } else {
            utm_term = getCookie(process.env.REACT_APP_NAME + "utm_term")
            if (!utm_term || utm_term === "undefined" || utm_term === undefined || utm_term === null || utm_term === "null") {
                utm_term = ""
            }
            utm_term = searchParams.get("utm_term")
        }

        if (searchParams.get("utm_id")) {
            utm_id = searchParams.get("utm_id")
            _finalData["utm_id"] = utm_id
        } else {
            utm_id = getCookie(process.env.REACT_APP_NAME + "utm_id")
            if (!utm_id || utm_id === "undefined" || utm_id === undefined || utm_id === null || utm_id === "null") {
                utm_id = ""
            }
            _finalData["utm_id"] = utm_id
        }

        if (searchParams.get("utm_content")) {
            utm_content = searchParams.get("utm_content")
            _finalData["utm_content"] = utm_content
        } else {
            utm_content = getCookie(process.env.REACT_APP_NAME + "utm_content")
            if (!utm_content || utm_content === "undefined" || utm_content === undefined || utm_content === null || utm_content === "null") {
                utm_content = ""
            }
            _finalData["utm_content"] = utm_content
        }

        if (searchParams.get("utm_medium")) {
            utm_medium = searchParams.get("utm_medium")
            _finalData["utm_medium"] = utm_medium
        } else {
            utm_medium = getCookie(process.env.REACT_APP_NAME + "utm_medium")
            if (!utm_medium || utm_medium === "undefined" || utm_medium === undefined || utm_medium === null || utm_medium === "null") {
                utm_medium = ""
            }
            _finalData["utm_medium"] = utm_medium
        }

        if (searchParams.get("utm_campaign")) {
            utm_campaign = searchParams.get("utm_campaign")
            _finalData["utm_campaign"] = utm_campaign
        } else {
            utm_campaign = getCookie(process.env.REACT_APP_NAME + "utm_campaign")
            if (!utm_campaign || utm_campaign === "undefined" || utm_campaign === undefined || utm_campaign === null || utm_campaign === "null") {
                utm_campaign = ""
            }
            _finalData["utm_campaign"] = utm_campaign
        }

        setTimeout(() => {
            setFinalData(_finalData)
        }, 100);

        //

        setCookie(process.env.REACT_APP_NAME + "utm_source", utm_source, 0.5)
        setCookie(process.env.REACT_APP_NAME + "utm_id", utm_id, 0.5)
        setCookie(process.env.REACT_APP_NAME + "utm_content", utm_content, 0.5)
        setCookie(process.env.REACT_APP_NAME + "utm_medium", utm_medium, 0.5)
        setCookie(process.env.REACT_APP_NAME + "utm_campaign", utm_campaign, 0.5)
        setCookie(process.env.REACT_APP_NAME + "utm_term", utm_term, 0.5)

    }, [])

    useEffect(() => {
        const handleScroll = () => setIsFooterVisible(window.scrollY > 300);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [])

    const scrollToDonation = () => {
        document.getElementById("donation-form").scrollIntoView({behavior: "smooth"});
    };

    return (
        <>
            <div id="donation-form">
                <>
                    <section className="home-slider position-relative">
                        <img
                            src={fullScreen ? (imgDonacion ? mobileFondoDonacion : mobileFondoPrincipal) : (imgDonacion ? fondoDonacion : fondoPrincipal)}
                            alt='image'/>
                        {fullScreen && imgDonacion && false && (
                            <div className="donation-legend" style={{
                                zIndex: 800,
                                position: "absolute",
                                padding: "23px 10px",
                                bottom: "20px",
                                maxWidth: "50%"
                            }}>

                                <div>
                                    <p style={{
                                        fontSize: "1.5rem",
                                        color: "#ffffff",
                                        lineHeight: 1.1,
                                        textAlign: "left",
                                        paddingLeft: "20px"
                                    }}
                                       className={"font-face-UniversBold"}>Con {amount} Bs</p>
                                    <p style={{
                                        fontSize: "1rem",
                                        color: "#ffffff",
                                        lineHeight: 1.1,
                                        textAlign: "left",
                                        paddingLeft: "20px"
                                    }}
                                       className={"font-face-UniversLight"}>lograr&aacute;s transformar vidas</p>
                                </div>
                            </div>
                        )}
                        {!fullScreen && imgDonacion && false && (
                            <div style={{
                                flex: "50%",
                                position: "absolute",
                                bottom: "15%",
                                right: "5%"
                            }}>

                                <div>
                                    <p style={{
                                        fontSize: "4rem",
                                        color: "#ffffff",
                                        lineHeight: 1.1,
                                        textAlign: "right"
                                    }}
                                       className={"font-face-UniversRegular"}>Con {amount} Bs</p>
                                    <p style={{
                                        fontSize: "2rem",
                                        color: "#ffffff",
                                        lineHeight: 1.1,
                                        textAlign: "right"
                                    }}
                                       className={"font-face-UniversLight"}>lograr&aacute;s transformar vidas</p>
                                </div>

                            </div>
                        )}
                        {(
                            <div>
                                <div style={!fullScreen ? {
                                    zIndex: 9999,
                                    display: "flex",
                                    flexDirection: "column",
                                    position: "absolute",
                                    bottom: "20%",
                                    paddingLeft: "8%",
                                    maxWidth: "50%",
                                    padding: "23px 25px"
                                } : {
                                    display: "flex",
                                    position: "absolute",
                                    top: "55%",
                                    width: "82%",
                                    padding: "23px 10px"
                                }}>

                                    {!fullScreen && (
                                        <div className={"row"} style={{flex: "50%"}}>
                                            <Grid container spacing={0} columnSpacing={2}>
                                                <Grid item xs={12}>
                                                    <Typography
                                                        variant="h5"
                                                        style={{
                                                            textAlign: "center",
                                                            color: "#fff",
                                                            fontWeight: "bold",
                                                            marginBottom: "10px"
                                                        }}
                                                        className="font-face-UniversBold"
                                                    >
                                                        Selecciona el monto que quieres donar.
                                                    </Typography>
                                                </Grid>
                                                <Grid item lg={3} xs={3}>
                                                    <ColorButton style={{
                                                        color: amount === 120 ? "#0737A0" : "#FEFD02",
                                                        borderRadius: 45,
                                                        textTransform: "capitalize",
                                                        border: "2px solid #FEFD02",
                                                        backgroundColor: amount === 120 ? "#FEFD02" : "#0737A0",
                                                        marginTop: "20px",
                                                        width: "100%"
                                                    }} onClick={() => {
                                                        setError("");
                                                        setAmount(120);
                                                        setIsFirstClick(false);
                                                        setShowAmount(false);
                                                        setImgDonacion(true)
                                                    }} variant="contained"><span
                                                        className={"font-face-UniversBold"}>Bs 120</span></ColorButton>
                                                </Grid>

                                                <Grid item lg={3} xs={3} style={{position: "relative"}}>
                                                    <div style={{
                                                        position: "absolute",
                                                        top: "-8px",
                                                        left: "50%",
                                                        transform: "translateX(-40%)",
                                                        backgroundColor: "#FEFD02",
                                                        color: "#0737A0",
                                                        padding: "4px 12px",
                                                        borderRadius: "12px",
                                                        fontSize: "11px",
                                                        fontWeight: "bold",
                                                        zIndex: 10,
                                                        whiteSpace: "nowrap"
                                                    }}>
                                                        Popular
                                                    </div>
                                                    <div style={{
                                                        border: "2px dashed #FEFD02",
                                                        borderRadius: "50px",
                                                        padding: "4px",
                                                        position: "relative",
                                                        marginTop: "12px"
                                                    }}>
                                                        <ColorButton style={{
                                                            color: amount === 180 ? "#0737A0" : "#FEFD02",
                                                            borderRadius: 45,
                                                            textTransform: "capitalize",
                                                            border: "2px solid #FEFD02",
                                                            backgroundColor: amount === 180 ? "#FEFD02" : "#0737A0",
                                                            width: "100%"
                                                        }} onClick={() => {
                                                            setError("");
                                                            setAmount(180);
                                                            setIsFirstClick(false);
                                                            setShowAmount(false);
                                                            setImgDonacion(true)
                                                        }} variant="contained"><span
                                                            className={"font-face-UniversBold"}>Bs 180</span></ColorButton>
                                                    </div>
                                                    <div style={{
                                                        position: "absolute",
                                                        bottom: "-28px",
                                                        left: "50%",
                                                        transform: "translateX(-45%)",
                                                        color: "#FEFD02",
                                                        fontSize: "11px",
                                                        fontWeight: "bold",
                                                        textAlign: "center",
                                                        zIndex: 10,
                                                        whiteSpace: "nowrap",
                                                        lineHeight: "1"
                                                    }}>
                                                        <div style={{fontSize: "24px", marginBottom: "-2px"}}>&#9660;</div>
                                                        Opción más elegida
                                                    </div>
                                                </Grid>
                                                <Grid item lg={3} xs={3}>
                                                    <ColorButton style={{
                                                        color: amount === 240 ? "#0737A0" : "#FEFD02",
                                                        borderRadius: 45,
                                                        textTransform: "capitalize",
                                                        border: "2px solid #FEFD02",
                                                        backgroundColor: amount === 240 ? "#FEFD02" : "#0737A0",
                                                        marginTop: "20px",
                                                        width: "100%"
                                                    }} onClick={() => {
                                                        setError("");
                                                        setAmount(240);
                                                        setIsFirstClick(false);
                                                        setShowAmount(false);
                                                        setImgDonacion(true)
                                                    }} variant="contained"><span
                                                        className={"font-face-UniversBold"}>Bs 240</span></ColorButton>
                                                </Grid>
                                                <Grid item lg={3} xs={3}>
                                                    <ColorButton
                                                        style={{
                                                            color: amount !== 120 && amount !== 180 && amount !== 240 && showAmount ? "#0737A0" : "#FEFD02",
                                                            borderRadius: 45,
                                                            textTransform: "capitalize",
                                                            border: "2px solid #FEFD02",
                                                            backgroundColor: amount !== 120 && amount !== 180 && amount !== 240 && showAmount ? "#FEFD02" : "#0737A0",
                                                            fontSize: "1.1rem",
                                                            lineHeight: "1",
                                                            marginTop: "20px",
                                                            width: "100%"
                                                        }} onClick={() => {
                                                        setAmount(240);
                                                        setIsFirstClick(false);
                                                        setShowAmount(true);
                                                        setImgDonacion(true)
                                                    }} variant="contained"><span className={"font-face-UniversBold"}>Otro Monto</span></ColorButton>
                                                </Grid>
                                                <Grid item lg={12} xs={12}
                                                      sx={{mt: {xs: 2, md: 2, lg: 2}}}
                                                >
                                                </Grid>

                                                <Grid item lg={12} xs={12} mt={1} style={{textAlign: "center"}}>
                                                    {showAmount ?
                                                        <ButtonGroup
                                                            style={{width: "100%"}}
                                                            disableElevation
                                                            variant="contained"
                                                        >
                                                            <TextField style={{width: "50%"}}
                                                                       className="amount-text"
                                                                       value={amount}
                                                                       onChange={handleChange}
                                                                       onKeyDown={handleChange}/>
                                                            <ColorButton onClick={donate} style={{
                                                                width: "50%",
                                                                backgroundColor: "#0737A0",
                                                                color: "#FEFD02"
                                                            }}><span
                                                                className={"font-face-UniversBold"}>Dona Ahora</span></ColorButton>
                                                        </ButtonGroup>
                                                        :
                                                        <ColorButton style={{
                                                            borderRadius: 35, backgroundColor: "#0737A0",
                                                            color: "#FEFD02", width: "60%"
                                                        }}
                                                                     onClick={donate}><span className={"font-face-UniversBold"}>DONAR AHORA</span></ColorButton>
                                                    }
                                                </Grid>

                                                {error !== "" &&
                                                    <Grid item lg={12} xs={12} mt={1}>
                                                        <div style={{
                                                            background: "#000",
                                                            zIndex: "99",
                                                            fontSize: "1rem",
                                                            fontWeight: 600,
                                                            textAlign: "center",
                                                            color: "#fff",
                                                            padding: 5,
                                                            borderRadius: 5
                                                        }}>
                                                            <WarningAmberIcon variant="h6"
                                                                              sx={{fontSize: "2rem", marginRight: 1}}/>
                                                            {error}
                                                        </div>
                                                    </Grid>
                                                }
                                                <Grid item lg={12} xs={12} mt={1}>
                                                    <p style={{color: '#FEFD02', fontSize: '0.8rem', textAlign: 'center', margin: '8px 0 0'}}>
                                                        * Con cada Bs 50 donados participas del sorteo de los premios de la Teletón 2026
                                                    </p>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </section>

                </>
            </div>
            {fullScreen && (
                <>
                    <div className="donation-form"
                         style={{width: "100%", padding: "0"}}>
                        <Grid container spacing={0}>
                            <Grid item xs={12} style={{backgroundColor: "#0737A0", width: "100%"}}>
                                <Typography
                                    sx={{mb: 2, mt: 2}}
                                    variant="h5"
                                    style={{
                                        textAlign: "center",
                                        color: "#FEFD02",
                                        marginTop: "16px",
                                        marginBottom: "16px",
                                    }}>
                                <span className="font-face-UniversBold">
                                    Selecciona el monto que quieres donar.
                                </span>
                                </Typography>
                            </Grid>
                            {/* Row 1 - 120 and 170 */}
                            <Grid item xs={6}>
                                <ColorButton style={{
                                    color: amount === 120 ? "#0737A0" : "#FEFD02",
                                    borderRadius: 45,
                                    textTransform: "capitalize",
                                    border: "2px solid #FEFD02",
                                    backgroundColor: amount === 120 ? "#FEFD02" : "#0737A0",
                                    marginTop: "8px"
                                }} onClick={() => {
                                    setError("");
                                    setAmount(120);
                                    setShowAmount(false);
                                    setImgDonacion(true)
                                }} variant="contained"><span
                                    className={"font-face-UniversBold"}>Bs 120</span></ColorButton>
                            </Grid>
                            <Grid item xs={6} style={{position: "relative"}}>
                                <div style={{
                                    position: "absolute",
                                    top: "-8px",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    backgroundColor: "#FEFD02",
                                    color: "#0737A0",
                                    padding: "4px 12px",
                                    borderRadius: "12px",
                                    fontSize: "11px",
                                    fontWeight: "bold",
                                    zIndex: 10,
                                    whiteSpace: "nowrap"
                                }}>
                                    Popular
                                </div>
                                <div style={{
                                    border: "2px dashed #FEFD02",
                                    borderRadius: "50px",
                                    padding: "4px",
                                    position: "relative",
                                    marginTop: "0px"
                                }}>
                                    <ColorButton style={{
                                        color: amount === 180 ? "#0737A0" : "#FEFD02",
                                        borderRadius: 45,
                                        textTransform: "capitalize",
                                        border: "2px solid #FEFD02",
                                        backgroundColor: amount === 180 ? "#FEFD02" : "#0737A0",
                                    }} onClick={() => {
                                        setError("");
                                        setAmount(180);
                                        setShowAmount(false);
                                        setImgDonacion(true)
                                    }} variant="contained"><span
                                        className={"font-face-UniversBold"}>Bs 180</span></ColorButton>
                                </div>
                                <div style={{
                                    position: "absolute",
                                    bottom: "-27px",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    color: "#FEFD02",
                                    fontSize: "11px",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    zIndex: 10,
                                    whiteSpace: "nowrap",
                                    lineHeight: "1"
                                }}>
                                    <div style={{fontSize: "24px", marginBottom: "-2px"}}>&#9660;</div>
                                    Opción más elegida
                                </div>
                            </Grid>
                            {/* Row 2 - 250 and Otro Monto */}
                            <Grid item xs={6} style={{marginTop: "30px"}}>
                                <ColorButton style={{
                                    color: amount === 240 ? "#0737A0" : "#FEFD02",
                                    borderRadius: 45,
                                    textTransform: "capitalize",
                                    border: "2px solid #FEFD02",
                                    backgroundColor: amount === 240 ? "#FEFD02" : "#0737A0",
                                }} onClick={() => {
                                    setError("");
                                    setAmount(240);
                                    setShowAmount(false);
                                    setImgDonacion(true)
                                }} variant="contained"><span
                                    className={"font-face-UniversBold"}>Bs 240</span></ColorButton>
                            </Grid>
                            <Grid item xs={6} style={{marginTop: "30px"}}>
                                <ColorButton
                                    style={{
                                        color: amount !== 120 && amount !== 180 && amount !== 240 && showAmount ? "#0737A0" : "#FEFD02",
                                        borderRadius: 45,
                                        textTransform: "capitalize",
                                        border: "2px solid #FEFD02",
                                        backgroundColor: amount !== 120 && amount !== 180 && amount !== 240 && showAmount ? "#FEFD02" : "#0737A0",
                                        fontSize: "1.1rem",
                                        lineHeight: "1"
                                    }} onClick={() => {
                                    setAmount(240);
                                    setShowAmount(true);
                                    setImgDonacion(true)
                                }} variant="contained"><span className={"font-face-UniversBold"}>Otro Monto</span></ColorButton>
                            </Grid>

                            <Grid item xs={12} mt={1} style={{textAlign: "center"}}>
                                {showAmount ?
                                    <ButtonGroup
                                        style={{width: "100%"}}
                                        disableElevation
                                        variant="contained"
                                    >
                                        <TextField style={{width: "50%"}}
                                                   className="amount-text"
                                                   value={amount}
                                                   onChange={handleChange}
                                                   onKeyDown={handleChange}/>
                                        <ColorButton onClick={donate} style={{width: "50%",
                                            backgroundColor: "#0737A0",
                                            color:"#FEFD02"}}><span
                                            className={"font-face-UniversBold"}>Dona Ahora</span></ColorButton>
                                    </ButtonGroup>
                                    :
                                    <ColorButton style={{borderRadius: 35, width: "50%", backgroundColor: "#0737A0",
                                        color:"#FEFD02"}}
                                                 onClick={donate}><span className={"font-face-UniversBold"}>DONAR AHORA</span></ColorButton>
                                }
                            </Grid>

                            {error !== "" &&
                                <Grid item xs={12} mt={1}>
                                    <div style={{
                                        background: "#000",
                                        zIndex: "99",
                                        fontSize: "1rem",
                                        fontWeight: 600,
                                        textAlign: "center",
                                        color: "#fff",
                                        padding: 5,
                                        borderRadius: 5
                                    }}>
                                        <WarningAmberIcon variant="h6" sx={{fontSize: "2rem", marginRight: 1}}/>
                                        {error}
                                    </div>
                                </Grid>
                            }
                            <Grid item xs={12} mt={1}>
                                <p style={{color: '#FEFD02', fontSize: '0.8rem', textAlign: 'center', margin: '8px 0 0'}}>
                                    * Con cada Bs 50 donados participas del sorteo de los premios de la Teletón 2026
                                </p>
                            </Grid>
                        </Grid>
                    </div>

                </>
            )}

            {/* ====== PAGE BODY SECTIONS (shared desktop/mobile) ====== */}

            {/* Section 1: Problem - 4 de cada 10 */}
            <section className="tda2026-problem">
                <div className="tda2026-problem__inner">
                    <div className="tda2026-problem__photo-wrap">
                        <img src={`${ASSETS}/girl-poverty.png`} alt="Niña boliviana" className="tda2026-problem__photo" />
                    </div>
                    <div className="tda2026-problem__content">
                        <div className="tda2026-problem__stat">
                            <span className="tda2026-problem__stat-number">4</span>
                            <span className="tda2026-problem__stat-middle">
                                <span className="tda2026-problem__stat-de">de</span>
                                <span className="tda2026-problem__stat-cada">cada</span>
                            </span>
                            <span className="tda2026-problem__stat-number">10</span>
                        </div>
                        <p className="tda2026-problem__headline">
                            niñas, niños y adolescentes en Bolivia viven en situación de pobreza multidimensional
                        </p>
                        <p className="tda2026-problem__desc">
                            y las brechas en salud, educación, protección y acceso a servicios básicos presentan indicadores negativos.
                        </p>
                    </div>
                </div>
            </section>

            {/* Section 2: Prizes */}
            <section className="tda2026-prizes">
                <img src={`${ASSETS}/heart-light.png`} alt="" className="tda2026-prizes__bg" aria-hidden="true" />
                <div className="tda2026-prizes__inner">
                    <h2 className="tda2026-prizes__title">
                        Con tu donación participas del sorteo de <span>grandes premios.</span>
                    </h2>

                    {!fullScreen && (
                        <img src={`${ASSETS}/premios-landing.png`} alt="Premios" className="tda2026-prizes__img" />
                    )}

                    {fullScreen && (
                        <div className="tda2026-prizes-mobile">
                            <div className="tda2026-prizes-mobile__main">
                                <img src={`${ASSETS}/prizes/auto.png`} alt="Suzuki Alto 0Km" className="tda2026-prizes-mobile__car" />
                                <p className="tda2026-prizes-mobile__car-label">Suzuki Alto 0Km</p>
                            </div>
                            <Swiper
                                modules={[Autoplay]}
                                slidesPerView={2.5}
                                spaceBetween={15}
                                loop={true}
                                autoplay={{delay: 2500, disableOnInteraction: false}}
                                className="tda2026-prizes-mobile__carousel"
                            >
                                {[
                                    {img: 'pasajes.png', label: 'Paquete vacacional'},
                                    {img: 'poliza.png', label: 'Póliza automotriz'},
                                    {img: 'peya2.png', label: 'Vales Pedidos Ya'},
                                    {img: 'polera-1.jpg', label: 'Polera Messi'},
                                    {img: 'poleras-grupo.png', label: 'Poleras autografiadas'},
                                    {img: 'hervidora.png', label: 'Hervidores eléctricos'},
                                    {img: 'tostadora.png', label: 'Tostadoras'},
                                    {img: 'vales-consumo.png', label: 'Vales de consumo'},
                                ].map((prize, i) => (
                                    <SwiperSlide key={i}>
                                        <div className="tda2026-prizes-mobile__item">
                                            <img src={`${ASSETS}/prizes/${prize.img}`} alt={prize.label} className="tda2026-prizes-mobile__item-img" />
                                            <p className="tda2026-prizes-mobile__item-label">{prize.label}</p>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    )}

                    <div className="tda2026-prizes__list-wrap">
                        <p className="tda2026-prizes__list-title">Lista de premios</p>
                        <Swiper
                            modules={[Autoplay]}
                            direction="vertical"
                            slidesPerView={3}
                            spaceBetween={0}
                            loop={true}
                            loopAdditionalSlides={3}
                            autoplay={{delay: 1000, disableOnInteraction: false, pauseOnMouseEnter: true}}
                            speed={400}
                            className="tda2026-prizes__ticker"
                        >
                            {[
                                '1 Suzuki Alto modelo 2027 (0 Km)',
                                '1 paquete vacacional al caribe para 2 personas todo pagado (incluye Pasajes de avión)',
                                '1 póliza automotriz',
                                '10 vales de consumo de Pedidos Ya por Bs. 1.000 cada uno',
                                '1 polera del FC Barcelona (temporada 2021) autografiada por Lionel Messi (con certificado de autenticidad)',
                                '1 polera autografiada de la selección boliviana',
                                '1 polera autografiada del club Bolivar',
                                '1 polera autografiada del club The Strongest',
                                '1 polera autografiada del club Oriente Petrolero',
                                '1 polera autografiada del club Blooming',
                                '5 hervidores eléctricos de 1.7 L marca Masterpro',
                                '2 tostadoras de 2 rebanadas marca Masterpro',
                                '2 vales de consumo de Bs. 500 cada uno del restaurante Caudila (Santa Cruz)',
                                '2 vales de consumo de Bs. 500 cada uno del restaurante El Arriero (Santa Cruz)',
                            ].map((prize, i) => (
                                <SwiperSlide key={i}>
                                    <div className="tda2026-prizes__ticker-item">
                                        <span className="tda2026-prizes__ticker-bullet">&#9733;</span>
                                        <span>{prize}</span>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </section>

            {/* Section 3: Water / Rural */}
            <section className="tda2026-water">
                <div className="tda2026-water__inner">
                    <div className="tda2026-water__content">
                        <p className="tda2026-water__intro">En varias comunidades rurales,</p>
                        <div className="tda2026-water__stat">
                            <span className="tda2026-water__stat-number">4</span>
                            <span className="tda2026-water__stat-middle">
                                <span className="tda2026-water__stat-de">de</span>
                                <span className="tda2026-water__stat-cada">cada</span>
                            </span>
                            <span className="tda2026-water__stat-number">10</span>
                        </div>
                        <p className="tda2026-water__headline">
                            familias todavía no cuentan con agua potable en su hogar.
                        </p>
                    </div>
                    <div className="tda2026-water__photo-wrap">
                        <img src={`${ASSETS}/girl-water.png`} alt="Niña con agua" className="tda2026-water__photo" />
                    </div>
                </div>
                <div className="tda2026-water__cta-bar">
                    <p className="tda2026-water__cta-text">En tus manos está cambiar sus vidas</p>
                    <button className="tda2026-cta" onClick={scrollToDonation}>DONA AHORA &gt;</button>
                </div>
            </section>

            {/* Section 3: Impact Areas */}
            <section className="tda2026-impact">
                <div className="tda2026-impact__inner">
                    <h2 className="tda2026-impact__title">
                        Todo lo recaudado contribuirá a que <span>UNICEF</span> llegue a miles de niñas, niños y adolescentes:
                    </h2>
                    <div className="tda2026-impact__grid">
                        <div className="tda2026-impact__card">
                            <img src={`${ASSETS}/icon-education.png`} alt="" className="tda2026-impact__card-icon" />
                            <h3 className="tda2026-impact__card-title">Educación</h3>
                            <p className="tda2026-impact__card-stat">50 escuelas</p>
                            <p className="tda2026-impact__card-desc">Se apoyará la mejora de las habilidades de lectoescritura y se ampliarán las oportunidades para acceder a experiencias de ciencia y tecnología.</p>
                        </div>
                        <div className="tda2026-impact__card">
                            <img src={`${ASSETS}/icon-health.png`} alt="" className="tda2026-impact__card-icon" />
                            <h3 className="tda2026-impact__card-title">Salud</h3>
                            <p className="tda2026-impact__card-stat">60.000 niñas y niños</p>
                            <p className="tda2026-impact__card-desc">Menores de cinco años y la distribución de más de <strong>1,2 millones de dosis de vitamina A.</strong></p>
                        </div>
                        <div className="tda2026-impact__card">
                            <img src={`${ASSETS}/icon-water.png`} alt="" className="tda2026-impact__card-icon" />
                            <h3 className="tda2026-impact__card-title">Agua e higiene</h3>
                            <p className="tda2026-impact__card-stat">30 escuelas</p>
                            <p className="tda2026-impact__card-desc">Se contribuirá a mejorar los servicios higiénicos y a la construcción de baños para familias vulnerables en zonas rurales de Potosí.</p>
                        </div>
                        <div className="tda2026-impact__card">
                            <img src={`${ASSETS}/icon-protection.png`} alt="" className="tda2026-impact__card-icon" />
                            <h3 className="tda2026-impact__card-title">Protección</h3>
                            <p className="tda2026-impact__card-stat">50 centros de salud</p>
                            <p className="tda2026-impact__card-desc">Se fortalecerán 50 centros de salud para mejorar la detección y atención temprana de adolescentes que requieran apoyo.</p>
                        </div>
                        <div className="tda2026-impact__card tda2026-impact__card--wide">
                            <img src={`${ASSETS}/icon-family.png`} alt="" className="tda2026-impact__card-icon" />
                            <h3 className="tda2026-impact__card-title">Familias</h3>
                            <p className="tda2026-impact__card-stat">1.600 familias</p>
                            <p className="tda2026-impact__card-desc">En situación de vulnerabilidad recibirán las herramientas y la orientación que necesitan para acompañar el desarrollo de sus hijas e hijos en casa.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 4: Final CTA */}
            <section className="tda2026-final-cta">
                <button className="tda2026-cta" onClick={scrollToDonation}>DONA AHORA &gt;</button>
            </section>

            {/* Section 5: Sponsors */}
            <section className="tda2026-sponsors">
                <div className="tda2026-sponsors__inner">
                    <p className="tda2026-sponsors__title">Con el apoyo de:</p>
                    {fullScreen ? (
                        <Swiper
                            modules={[Autoplay]}
                            slidesPerView={3}
                            spaceBetween={20}
                            loop={true}
                            autoplay={{delay: 2000, disableOnInteraction: false}}
                            className="tda2026-sponsors__carousel"
                        >
                            {[
                                {file: '01-suzuki.png', alt: 'Suzuki'},
                                {file: '02-imcruz.png', alt: 'Imcruz'},
                                {file: '03-entel.png', alt: 'Entel'},
                                {file: '04-bisa-seguros.png', alt: 'BISA Seguros'},
                                {file: '05-estropical.png', alt: 'EsTropical'},
                                {file: '06-expocruz.png', alt: 'Expocruz'},
                                {file: '07-finesse.png', alt: 'Finesse'},
                                {file: '08-fundacion-vida.png', alt: 'Fundación Nacional Vida'},
                                {file: '09-banco-bisa.png', alt: 'Banco BISA'},
                                {file: '10-haka-group.png', alt: 'Haka Group'},
                                {file: '11-los-tajibos.png', alt: 'Los Tajibos'},
                                {file: '12-nexocorp-farmacorp.png', alt: 'Nexocorp Farmacorp'},
                                {file: '13-banco-economico.png', alt: 'Banco Económico'},
                                {file: '14-pedidos-ya.png', alt: 'Pedidos Ya'},
                            ].map((logo, i) => (
                                <SwiperSlide key={i}>
                                    <img src={`${ASSETS}/sponsors/${logo.file}`} alt={logo.alt} className="tda2026-sponsors__logo" />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    ) : (
                        <div className="tda2026-sponsors__grid">
                            {[
                                {file: '01-suzuki.png', alt: 'Suzuki'},
                                {file: '02-imcruz.png', alt: 'Imcruz'},
                                {file: '03-entel.png', alt: 'Entel'},
                                {file: '04-bisa-seguros.png', alt: 'BISA Seguros'},
                                {file: '05-estropical.png', alt: 'EsTropical'},
                                {file: '06-expocruz.png', alt: 'Expocruz'},
                                {file: '07-finesse.png', alt: 'Finesse'},
                                {file: '08-fundacion-vida.png', alt: 'Fundación Nacional Vida'},
                                {file: '09-banco-bisa.png', alt: 'Banco BISA'},
                                {file: '10-haka-group.png', alt: 'Haka Group'},
                                {file: '11-los-tajibos.png', alt: 'Los Tajibos'},
                                {file: '12-nexocorp-farmacorp.png', alt: 'Nexocorp Farmacorp'},
                                {file: '13-banco-economico.png', alt: 'Banco Económico'},
                                {file: '14-pedidos-ya.png', alt: 'Pedidos Ya'},
                            ].map((logo, i) => (
                                <img key={i} src={`${ASSETS}/sponsors/${logo.file}`} alt={logo.alt} className="tda2026-sponsors__logo" />
                            ))}
                        </div>
                    )}
                </div>
            </section>

            {/* Sticky footer */}
            {isFooterVisible && (
                <footer className="tda2026-sticky-footer">
                    <div className="tda2026-sticky-footer__inner">
                        <p className="tda2026-sticky-footer__text">
                            Ayuda a miles de niños en Bolivia
                        </p>
                        <button className="tda2026-sticky-footer__btn" onClick={scrollToDonation}>
                            DONA AHORA
                        </button>
                    </div>
                </footer>
            )}
        </>
    );
}

OneShot.propTypes = {};

export default OneShot;
